<template>
    <div class="common">
        <div v-if="videoLists">
            <div class="control-height">
                <nav class="down-pull">
                <div class="pull pull1">
                    <div class="title">{{pull1Current.value}}</div>
                    <ul>
                        <li @click="changPull1(item)" v-for="(item,index) in pull1" :key="index">{{item.value}}</li>
                    </ul>
                    <i></i>
                </div>

                <div class="pull pull2">  
                    <div class="title">{{pull2Current.value}}</div>
                    <ul>
                        <li @click="changPull2(item)" v-for="(item,index) in pull2" :key="index">{{item.value}}</li>
                    </ul>
                    <i></i>
                </div>
                <div class="pull pull3"> 
                    <div class="title">{{pull3Current.value}}</div>
                    <ul>
                        <li @click="changPull3(item)" v-for="(item,index) in pull3" :key="index">{{item.value}}</li>
                    </ul>
                    <i></i>
                </div>
                <div class="pull pull4"> 
                    <div class="title">{{pull4Current.value}}</div>
                    <ul>
                        <li @click="changPull4(item)" v-for="(item,index) in pull4" :key="index">{{item.value}}</li>
                    </ul>
                    <i></i>
                </div>
            </nav>
            <article class="content">
                <ul class="video-wrap">
                    <li class="video-item" v-for="(video,index) in videoLists" :key="index">
                        <a :href='video.v_type === "0" ? `//pcauto.pcvideo.com.cn/video-${video.id}.html` : `//pcauto.pcvideo.com.cn/video-${video.id}.html` ' target="_blank" :title="video.title.replace(/<[^>]+>/g, '')" @click="countAd(4274)">
                            <div class="imgArea">
                                <el-image :src="video.v_thumb_180_url" lazy></el-image>
                                <i></i>
                            </div>
                            <p class="tt" v-html="video.title"></p>
                            <em class="yc" v-if="video.original"></em>
                        </a>
                        <p class="td"><em>类型:</em>{{video.cluster_category}}</p>
                        <p class="td"><em>时长:</em>{{video.time_length}}</p>
                    </li>
                </ul>
            </article>
            <paging :totalPages=totalPages @reqData=reqVideoData ref="paging"></paging>
        </div>
        <search-box :id="2"></search-box>
        </div>
        <error-acrticle :id='4275' v-else></error-acrticle>
    </div>
</template>

<script>
import ErrorAcrticle from '../../global/ErrorAcrticle.vue'
    export default {
  components: { ErrorAcrticle },
        name: 'Common',
        data() {
            return {
                pull1Current: {value: '最相关', param:'', id: 0}, //第一个下拉框的当前列
                pull2Current: {value: '全部视频', param:'', id: 0}, //第二个下拉框的当前列
                pull3Current: {value: '全部时长', param:'', id: 0}, //第三个下拉框的当前列
                pull4Current: {value: '全部时间', param:'', id: 0}, //第四个下拉框的当前列
                pull1: [
                    {value: '最相关', param:'', id: 1},
                    {value: '最新发布', param:'time', id: 2},
                
                ],

                pull2: [],

                pull3: [    
                    {value: '全部时长', param:'', id: 1},
                    {value: '3分钟内', param:'three', id: 2},
                    {value: '3-10分钟', param:'ten', id: 3},
                    {value: '10分钟以上', param:'many', id: 4},
                ],
                
                pull4: [    
                    {value: '全部时间', param:'', id: 1},
                    {value: '一周内', param:'week', id: 2},
                    {value: '一个月内', param:'month', id: 3},
                    {value: '一年内', param:'year', id: 4},
                ],
                videoLists: [], //视频数据
                totalPages: 1, //总页数
                /* 
                *请求参数 
                */
                pageNo: 1, //请求页数
                sort:'', //排序
                clusterQuery: '', //类型
                videoTime: '', //视频时长
                searchTime: '', //查询时间类型
            }
        },
        methods: {
            changPull1(item) {
                this.countAd(4271)
                if(item.value === this.pull1Current.value) return
                this.pull1Current = item
                this.sort = item.param
                this.reqVideoData(this.pageNo)
            },
            changPull2(item) {
                this.countAd(4272)
                if(item.value === this.pull2Current.value) return
                this.pull2Current = item
                this.clusterQuery = item.param
                this.reqVideoData(this.pageNo)
            },
            changPull3(item) {
                if(item.value === this.pull3Current.value) return
                this.pull3Current = item
                this.videoTime = item.param
                this.reqVideoData(this.pageNo)
            },
            changPull4(item) {
                this.countAd(4273)
                if(item.value === this.pull4Current.value) return
                this.pull4Current = item
                this.searchTime = item.param
                this.reqVideoData(this.pageNo)
            },
            //重置搜索参数
            restParam() {
                this.sort = ''
                this.clusterQuery = ''
                this.videoTime = ''
                this.searchTime = ''
                this.pull1Current = {value: '最相关', param:'', id: 0}
                this.pull2Current = {value: '全部视频', param:'', id: 0}
                this.pull3Current = {value: '全部时长', param:'', id: 0}
                this.pull4Current = {value: '全部时间', param:'', id: 0}
            },
            async reqVideoData(pageNo = 1) {
                try {
                    const res = await this.fetVideoData({
                        q:this.$global.q,
                        pageNo,
                        sort:this.sort,
                        clusterQuery:this.clusterQuery,
                        videoTime:this.videoTime,
                        searchTime:this.searchTime
                    })
                    this.pageNo = pageNo
                    if(res) {
                        document.body.scrollTop = document.documentElement.scrollTop = 0
                    }                    
                    if(!res) {
                        this.restParam()
                    }
                    if(res.clusterResult) {
                        const clusterResult = Object.keys(res.clusterResult).map(v => {
                            return {value:v,param:v,id:res.clusterResult[v]}
                        })
                        this.pull2 = [{value: '全部视频', param:'', id: 0}]
                        this.pull2.push(...clusterResult)
                    }
                    this.videoLists = res.result
                    this.totalPages = res.totalPage
                } catch (error) {
                    console.error(error)
                }
            },
        },
        mounted() {
            // if(this.$global.tab.title == 'auto_video') {
                this.countColumnAd(3453)
                this.reqVideoData(this.pageNo)
                // this.$EventBus.$on(`${this.$global.tab.title}`,() => {this.reqVideoData(this.pageNo)})
            // }
        }
    }
</script>

<style lang="scss" scoped>
.common {
    width: 1020px;
    .down-pull {
        display: flex;
        font-size: 12px;
        color: #225599;
        margin-top: 5px;
        .pull {
            height: 28px;
            line-height: 28px;
            position: relative;
            margin-left: 10px;
            box-sizing: border-box;
                i {
                    display: block;
                    width: 7px;
                    height: 4px;
                    position: absolute;
                    right: 8px;
                    top: 11px;
                    overflow: hidden;
                    background-image: url($imageURL);
                    background-position: -8px -29px;
                }
            .title {
                width: 80px ;
                border: 1px solid transparent;
                padding-left: 6px;
                cursor: pointer;
                background-color: #fcfcfc;
            }
            ul {
                position: absolute;
                top: 28px;
                left: 0;
                display: none; 
                background-color: #fcfcfc; 
                width: 80px;
                cursor: pointer;
                color: #777777;
                z-index: 88;
            }
            li {
                width: 100%;
                padding-left: 6px;
                box-sizing: border-box;
                &:hover {
                    background-color: #f3f3f3;
                    color: #225599;
                }
            }
            &:first-of-type {
                margin-left: 0;
            }
                      &:hover {
                    ul{
                        display: block;
                        border: 1px solid #e5e5e5;
                    }
                    i {
                        transform: rotate(180deg);
                    }
                }
        }
    }
    .content {
        margin-top: -20px;
        .video-wrap {
            font-size: 12px;
            box-sizing: border-box;
            display: flex;
            flex-wrap: wrap;
            .video-item {
                position: relative;
                margin-left: 20px;
                width: 150px;
                margin-top: 25px;
                &:nth-of-type(6n+1) {
                    margin-left: 0;
                }
                a {
                    color: #225599;
                    cursor: pointer;
                    .imgArea  {
                        width: 150px;
                        height: 85px;
                        overflow: hidden;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                            opacity: 1;
                            &:hover {
                                transition: opacity 0.3s;
                                opacity: .5;
                            }
                        i {
                            top: 57px;
                            display: block;
                            width: 23px;
                            height: 23px;
                            background: url(//www1.pcauto.com.cn/2014/kuaisou/images/sp.png) no-repeat;
                            position: absolute;
                            right: 5px;
                            top: 59px;
                        }
                    }
                }
                .tt {
                    line-height: 18px;
                    padding-top: 7px;
                    height: 36px;
                    overflow: hidden;
                    font {
                        color: rgb(225, 9, 0);
                    }
                    ::v-deep em {
                        font-style: normal;
                        color: rgb(225, 9, 0);
                    }
                }
                .td {
                    line-height: 22px;
                    height: 22px;
                    color: #333333;
                    padding: 0;
                    em {
                        color: #777777;
                        font-style: normal;
                    }
                }
                .yc {
                    position: absolute;
                    width: 42px;
                    height: 42px;
                    background: url(//www1.pcauto.com.cn/20150115/kuaisou/images/img100.png) no-repeat;
                    left: 0;
                    top: 0;
                }
            }
        }
    }
}
</style>
    